import React from 'react';
import { Wrench, Clock3, FileText, Phone, UserCheck } from 'lucide-react';

const benefits = [
  { icon: <Phone className="text-blue-600 w-6 h-6" />, title: "Easy Communication", desc: "Support via client portal and email." },
  { icon: <Clock3 className="text-blue-600 w-6 h-6" />, title: "Fast Response", desc: "Same/next-day service" },
  { icon: <Wrench className="text-blue-600 w-6 h-6" />, title: "Multi-trade Services", desc: "One vendor for appliances, plumbing, HVAC, and electrical, etc." },
  { icon: <FileText className="text-blue-600 w-6 h-6" />, title: "Clean Reports", desc: "Digital reports with photos, notes, and invoices." },
  { icon: <UserCheck className="text-blue-600 w-6 h-6" />, title: "Vetted Technicians", desc: "Uniformed, insured, background-checked techs." },
];

const WhyMatanato = () => {
  return (
    <section className="bg-gray-50 py-10 px-4 md:px-10 rounded-2xl shadow-md max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-10">Why Choose Matanato?</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {benefits.map((item, index) => (
          <div key={index} className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow hover:shadow-md transition">
            <div>{item.icon}</div>
            <div>
              <h4 className="font-semibold text-lg text-gray-800">{item.title}</h4>
              <p className="text-gray-600 text-sm">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyMatanato;
